import {call, put} from 'redux-saga/effects';
import ReportActions from '../redux/ReportRedux';
import ReportsActions from '../redux/ReportsRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getReport(api, action) {
  const response = yield call(api.getReport, action.id);

  if (response.ok) {
    yield put(ReportActions.reportSuccess(response.data));
  } else {
    yield put(ReportActions.reportFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * addReport(api, action) {
  const response = yield call(api.addReport, {...action.data});

  if (response.ok) {
    yield put(ReportActions.reportSuccess(response.data));
    yield put(ReportsActions.reportsSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'reportAdd', title: 'Запись успешно создана'}));
  } else {
    yield put(ReportActions.reportFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * updateReport(api, action) {
  const response = yield call(api.editReport, {...action.data});

  if (response.ok) {
    yield put(ReportActions.reportSuccess(response.data));
    yield put(ReportsActions.reportsSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'reportUpdate', title: 'Запись успешно обновлена'}));
  } else {
    yield put(ReportActions.reportFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * deleteReport(api, action) {
  const response = yield call(api.deleteReport, action.id);

  if (response.ok) {
    yield put(ReportActions.reportSuccess(null));
    yield put(ReportsActions.reportsSuccess({removedId: action.id}));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'reportDelete', title: 'Запись успешно удалена'}));
  } else {
    yield put(ReportActions.reportFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
